<template>
  <router-view/>
</template>

<script>
export default {
  name: 'AffiliatesLegal',
}
</script>

<style>
.active-legal-tab {
  background: #0CA750;
  color: white !important;
}
</style>
